import store from "store";
import { logout } from "store/userSlice";

export const requestHandler = request => {
  const accessToken = store.getState().user.accessToken;
  if (
    !request.url.includes("/auth/social/") &&
    request.url !== "/auth/users/" &&
    accessToken !== "WP" &&
    !request.url.includes("/blog")
  ) {
    request.headers["Authorization"] = `JWT ${accessToken}`;
  }
  return request;
};

export const successHandler = response => {
  return response;
};

export const errorHandler = error => {
  if (error.message.includes("401")) {
    store.dispatch(logout());
    window.location = "/login";
  } else if (error.message.includes("403")) {
    if (window.location.href.includes("/subscribe")) {
      // FIXME check logic for this
      store.dispatch(logout());
      window.location = "/login";
    } else {
      window.location = "/subscribe";
    }
  }

  return Promise.reject({ ...error });
};
